import { Base } from '@studiometa/js-toolkit';

/**
 * Header class.
 */
export default class Header extends Base {
  /**
   * Class cofnig
   * @type {object}
   */
  static config = {
    name: 'Header',
    refs: ['burger[]', 'headerNav'],
  };

  /**
   * Mount component
   * @returns {void}
   */
  mounted() {
    this.menuIsOpen = false;
    this.body = document.querySelector('body');
  }

  /**
   * Handle burger click
   * @returns {void}
   */
  onBurgerClick() {
    if (this.menuIsOpen) this.closeMenu();
    else this.openMenu();
  }

  /**
   * Open menu nothing more
   * @returns {void}
   */
  openMenu() {
    this.body.classList.add('overflow-hidden', 'fixed', 'w-full');
    this.body.classList.add('menu-open');
    this.menuIsOpen = true;
  }

  /**
   * Close menu nothin more
   * @returns {void}
   */
  closeMenu() {
    this.body.classList.remove('overflow-hidden', 'fixed', 'w-full');
    this.body.classList.remove('menu-open');
    this.menuIsOpen = false;
    this.$children.MenuItem.filter((child) => child.$isMounted).forEach((child) =>
      child.closeSubmenu(),
    );
  }
}
